"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./InputBox.css");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
class InputBox extends _react.default.PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      editing: false
    });
  }
  render() {
    const {
      value,
      onChange,
      onBlur,
      editLabel
    } = this.props;
    const {
      editing
    } = this.state;
    const displayName = this.props.displayName || /*#__PURE__*/_react.default.createElement("span", {
      className: "displayName"
    }, value);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'input-box'
    }, !editing ? displayName : /*#__PURE__*/_react.default.createElement("input", {
      ref: "input",
      className: "input",
      value: value || '',
      onChange: event => onChange(event.target.value),
      disabled: !editing,
      onBlur: () => {
        this.setState({
          editing: false
        });
        if (typeof onBlur !== 'undefined' && typeof onBlur === 'function') {
          onBlur();
        }
      },
      onKeyPress: event => {
        if (event.key === 'Enter') {
          event.target.blur();
        }
      }
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "edit",
      onClick: () => {
        this.setState({
          editing: true
        }, () => {
          this.refs.input.focus();
          this.refs.input.select && this.refs.input.select();
        });
      }
    }, editLabel));
  }
}
exports.default = InputBox;